var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yue-dialog",
    {
      attrs: {
        title: "设置" + _vm.title,
        width: "1150px",
        "custom-class": "mark-teacher-dialog",
        top: "10vh",
        "append-to-body": "",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c("yue-read-teacher", {
        key: Date.now(),
        ref: "readTeacher",
        attrs: {
          "is-show-school": _vm.isRegion,
          "is-mark-setting": _vm.isMarkSetting,
          "is-show-teacher-manage": _vm.isShowTeacherManage,
          scene: _vm.scene,
        },
        scopedSlots: _vm._u(
          [
            _vm.isShowTeacherManage
              ? {
                  key: "header-right",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "font-weight": "normal" },
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/region/exam/single/teacher-manage/" +
                                  _vm.task.examId
                              )
                            },
                          },
                        },
                        [_vm._v("教师信息管理")]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "div",
        { staticClass: "btn-group", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.submit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }